import { axios } from '@Root/API'

export const remove = (studyProgrammeId, courseInitiativeId) => {
	return axios.delete(`program/${studyProgrammeId}/course-initiative/${courseInitiativeId}`)
}
